import { connect } from 'react-redux';

import GroupParticipantsList from './GroupParticipantsList';

import { selectors as groupSelectors } from '../../../../store/groups';

const mapStateToProps = (state, props) => {
  const group = groupSelectors.group(state, props.groupId) || {};
  const users = [...(group.educators || []), ...(group.students || [])];

  return {
    users,
  };
};

export default connect(mapStateToProps)(GroupParticipantsList);
